import { render } from "./BannerTop.vue?vue&type=template&id=8b9f89e2"
import script from "./BannerTop.vue?vue&type=script&lang=js"
export * from "./BannerTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__